interface EmptyStateProps {
  title: string;
  description?: string;
}

export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="card flex flex-col items-center gap-1 py-14 text-center">
      <p className="font-medium text-onyx">{title}</p>
      {description && <p className="text-sm text-onyx/50">{description}</p>}
    </div>
  );
}
